import { createReducer, on, Action } from "@ngrx/store";

import {
    openBackInStock,
    errorBackInStock,
    resetBackInStock,
    resetCustomerType,
    setCustomerType,
    successBackInStock,
} from "../actions/back-in-stock.actions";
import {
    BackInStockState,
    BackInStockStatus,
    initialBackInStockState,
} from "../models/back-in-stock.state";

export const BACK_IN_STOCK_FEATURE_KEY = "backInStock";

const openBackInStockReducer = (state: BackInStockState): BackInStockState => ({
    ...state,
    status: BackInStockStatus.Loading,
});

const resetBackInStockReducer = (): BackInStockState => ({
    ...initialBackInStockState,
});

const setCustomerTypeReducer = (
    state: BackInStockState,
    action: ReturnType<typeof setCustomerType>,
) => ({
    ...state,
    customerType: action.customerType,
});

const resetCustomerTypeReducer = (
    state: BackInStockState,
): BackInStockState => ({
    ...state,
    customerType: undefined,
});

const errorBackInStockReducer = (
    state: BackInStockState,
): BackInStockState => ({
    ...state,
    status: BackInStockStatus.Error,
});

const successBackInStockReducer = (
    state: BackInStockState,
): BackInStockState => ({
    ...state,
    status: BackInStockStatus.Success,
});

const internalReducer = createReducer(
    initialBackInStockState,
    on(openBackInStock, openBackInStockReducer),
    on(resetBackInStock, resetBackInStockReducer),
    on(setCustomerType, setCustomerTypeReducer),
    on(successBackInStock, successBackInStockReducer),
    on(resetCustomerType, resetCustomerTypeReducer),
    on(errorBackInStock, errorBackInStockReducer),
);

export const backInStockReducer = (
    state: BackInStockState,
    action: Action,
): BackInStockState => internalReducer(state, action);
